// extracted by mini-css-extract-plugin
module.exports = {"container":"DietsPageItemMini_container__1y4ib","img":"DietsPageItemMini_img__37AsA","title":"DietsPageItemMini_title__3K12Y"};